import styled from 'styled-components'

export const MobileButtonBox = styled.div`
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`
export const DesktopHidder = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    width: 25%;
  }
`
export const InputWider = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: 70%;
  }
`
